import { getSearch } from '../window';

/**
 * The email query param, which may be a plaintext address or base64 (Connect message
 * templates send {{encode64(Attributes.Customer.EmailAddress)}}; the backend tells the
 * two apart by looking for '@').
 *
 * URLSearchParams is deliberately NOT used here. It applies
 * application/x-www-form-urlencoded rules, where a literal '+' means a space, so it
 * turned a+b@gmail.com into "a b@gmail.com" and base64 containing '+' into garbage.
 * decodeURIComponent leaves '+' alone while still resolving any %XX escapes, which is
 * correct for both forms. Same reasoning as getEncodedEndpointId.
 */
export const getEmail = (): string | undefined => {
  const match = getSearch().match(/[?&]email=([^&]*)/)?.[1];

  if (!match) {
    return undefined;
  }

  try {
    return decodeURIComponent(match);
  } catch (e) {
    // decodeURIComponent throws URIError on a malformed escape such as %zz. The
    // previous URLSearchParams implementation returned the value as-is in that case,
    // so do the same rather than failing the whole page.
    return match;
  }
};
